module.exports = __webpack_public_path__ + "img/map.3ba062a0.png";